"use strict";
/*
  Some DOM elements are positioned relative to where a block starts. Since the left
  margin of the block is configurable, we need to calculate these.

  These items include:

  * Exclude from timing decorations that show up in the right gutter
  * Element numbers that show up in the left gutter
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementNumberLeftPx = exports.excludeFromTimingLeftPx = exports.chToPx = void 0;
// there are 9.6px in 1ch in the font we use. Multiplying by 9.6 gives
// many digits of converted binary precision, so we do 10x then divide
const TEN_CH_IN_PIXELS = 96;
const chToPx = (chValue) => {
    const tenXTooBig = TEN_CH_IN_PIXELS * chValue;
    return tenXTooBig / 10;
};
exports.chToPx = chToPx;
// we want the exclude from timing to show up 61ch to the right of the left gutter
const EXCLUDE_TIMING_LEFT_BASE_CH = 61;
const excludeFromTimingLeftPx = (blockMarginLeft) => {
    return (0, exports.chToPx)(EXCLUDE_TIMING_LEFT_BASE_CH - blockMarginLeft);
};
exports.excludeFromTimingLeftPx = excludeFromTimingLeftPx;
// element numbers are positioned 75px to the left of the page's left
const ELEMENT_NUMBER_LEFT_BASE_PX = 75;
const elementNumberLeftPx = (blockLeftMargin) => {
    const offset = (0, exports.chToPx)(blockLeftMargin) + ELEMENT_NUMBER_LEFT_BASE_PX;
    return offset * -1;
};
exports.elementNumberLeftPx = elementNumberLeftPx;
